/* eslint-disable indent */
export default function getRating(score) {
  return score >= 1 && score <= 2.5
    ? 'Good'
    : score > 2.5 && score <= 3.5
    ? 'Okay'
    : score > 3.5
    ? 'Improve'
    : ' '
}
